const SERVER_TIMESTAMP_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d+))?)?\s*(?:Z|z|[+-]\d{2}:?\d{2})?$/;
const DATETIME_LOCAL_PATTERN = /^(\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2})/;
const TIME_HH_MM_PATTERN = /^(\d{1,2}):(\d{2})/;

const pad = (n) => String(n).padStart(2, '0');

export const parseServerDate = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : new Date(value.getTime());
  if (typeof value === 'number') {
    const fromNumber = new Date(value);
    return Number.isNaN(fromNumber.getTime()) ? null : fromNumber;
  }
  const str = String(value).trim();
  const parts = str.match(SERVER_TIMESTAMP_PATTERN);
  if (parts) {
    const ms = parts[7] ? Number(parts[7].slice(0, 3).padEnd(3, '0')) : 0;
    return new Date(
      Number(parts[1]),
      Number(parts[2]) - 1,
      Number(parts[3]),
      Number(parts[4] || 0),
      Number(parts[5] || 0),
      Number(parts[6] || 0),
      ms
    );
  }
  const fallback = new Date(str);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
};

export const getServerTime = (value) => {
  const d = parseServerDate(value);
  return d ? d.getTime() : NaN;
};

export const formatDateTime = (value) => {
  const d = parseServerDate(value);
  return d ? d.toLocaleString() : '';
};

export const formatDate = (value) => {
  const d = parseServerDate(value);
  return d ? d.toLocaleDateString() : '';
};

export const formatLongDate = (value) => {
  const d = parseServerDate(value);
  if (!d) return '';
  return d.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
};

export const toDateInputValue = (value) => {
  const d = parseServerDate(value);
  if (!d) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const toDateTimeInputValue = (value) => {
  const d = parseServerDate(value);
  if (d) {
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
  const match = String(value || '').match(DATETIME_LOCAL_PATTERN);
  return match ? match[1].replace(' ', 'T') : '';
};

export const toTimeInputValue = (value) => {
  const d = parseServerDate(value);
  if (d) return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  const match = String(value || '').match(TIME_HH_MM_PATTERN);
  return match ? `${pad(Number(match[1]))}:${match[2]}` : '';
};
